// custom-link.js
// https://github.com/codex-team/editor.js/blob/master/src/components/inline-tools/inline-tool-link.ts

/* eslint-disable */

/**
 * Build styles
 */

require('./custom-link.css').toString();

export default class CustomLink {

  /**
   * Set a shortcut
   */
  get shortcut() {
    return 'CMD+W';
  }

  static get pasteConfig() {
    return false;
  }

  /*
  static get sanitize() {
    return {
      a: {
        class: 'custom-link',
      }
    };
  }*/

  static get sanitize() {
    return {
      a: {
        href: true,
        class: true,
        title: true,
        'data-link-name': true,
        'data-link-type': true,
        'data-real-href': true
      }
    };
  }

  static get isInline() {
    return true;
  }

  get state() {
    return this._state;
  }

  set state(state) {
    try {
      this._state = state;

      // Check if button, api, and api.styles exist before accessing them
      if (this.button && this.api && this.api.styles && this.api.styles.inlineToolButtonActive) {
        this.button.classList.toggle(this.api.styles.inlineToolButtonActive, state);
      } else {
        console.warn('Button, API, or styles not available in CustomLink.state setter');
      }
    } catch (error) {
      console.error('Error in CustomLink.state setter:', error);
      this._state = false;
    }
  }

  constructor({data, config, api}) {
    try {
      /**
       * Tool's initial config
       */
      // Ensure config is an object
      const safeConfig = config || {};

      this.config = {
        wikiPages: safeConfig.wikiPages || [],
        forms: safeConfig.forms || [],
        mode: safeConfig.mode
      };

      this.api = api;

      this.button = null;
      this._state = false;

      this.tag = 'a';
      this.class = 'custom-link';
      this.range = null;

      this.data = data || {};

      this._data = {
        link: '',
        meta: {}
      };

      this.nodes = {
          wrapper: null,
          container: null,
          input: null,
          inputHolder: null,
          ul: null,
      };

      // Ensure api and api.styles exist before accessing them
      this.CSS = {
          baseClass: (api && api.styles) ? api.styles.block : '',
          wrapper: 'custom-link-wrapper',
          wrapperShowed: 'custom-link-wrapper-showed',
          container: 'custom-link-container',
          filterHolder: 'custom-link-filter-holder',
          input: 'ce-inline-tool-input',
          inputShowed: 'ce-inline-tool-input--showed',
          inputEl: 'custom-link-tool__input-el',
          ul: 'custom-link-tool__ul',
          li: 'custom-link-tool__li'
      };

      this.inputOpened = false;

      this.showOnly = ''; // show wikis or forms only?
    } catch (error) {
      console.error('Error in CustomLink constructor:', error);
      // Set default values for essential properties
      this.config = { wikiPages: [], forms: [] };
      this.api = api || {};
      this.button = null;
      this._state = false;
      this.tag = 'a';
      this.class = 'custom-link';
      this.range = null;
      this.data = {};
      this._data = { link: '', meta: {} };
      this.nodes = {};
      this.CSS = {
        wrapper: 'custom-link-wrapper',
        wrapperShowed: 'custom-link-wrapper-showed',
        container: 'custom-link-container',
        filterHolder: 'custom-link-filter-holder',
        input: 'ce-inline-tool-input',
        inputShowed: 'ce-inline-tool-input--showed',
        inputEl: 'custom-link-tool__input-el',
        ul: 'custom-link-tool__ul',
        li: 'custom-link-tool__li'
      };
      this.inputOpened = false;
      this.showOnly = '';

      // Set up global link enhancement after editor is ready
      console.log('CustomLink constructor completed, setting up enhancement...');
      setTimeout(() => {
        console.log('Running _enhanceExistingLinks after 1 second delay...');
        this._enhanceExistingLinks();
      }, 1000);
      
      // Also try multiple times in case editor loads slowly
      setTimeout(() => {
        console.log('Running _enhanceExistingLinks after 3 second delay...');
        this._enhanceExistingLinks();
      }, 3000);
    }
  }

  save() {
    // Inline tools don't save data - they modify HTML directly
    // The links are already in the DOM via wrap() method
    return undefined;
  }

  clear() {
    this.closeActions();
  }

  render() {
    try {
      console.log('🔥 CustomLink render() called - creating W button');
      this.button = document.createElement('button');
      this.button.type = 'button';
      //this.button.textContent = 'Link Wiki';
      this.button.innerHTML = `<svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32px" height="32px"><path d="M 30 9.214844 C 30 9.386719 29.863281 9.523438 29.6875 9.523438 L 28.007813 9.523438 L 20.390625 25.738281 C 20.339844 25.847656 20.230469 25.917969 20.113281 25.917969 C 20.109375 25.917969 20.109375 25.917969 20.109375 25.917969 C 19.988281 25.917969 19.882813 25.851563 19.828125 25.746094 L 16.214844 18.578125 L 12.3125 25.757813 C 12.257813 25.859375 12.15625 25.917969 12.03125 25.917969 C 11.914063 25.914063 11.808594 25.847656 11.757813 25.742188 L 4.054688 9.523438 L 2.3125 9.523438 C 2.140625 9.523438 2 9.386719 2 9.214844 L 2 8.390625 C 2 8.21875 2.140625 8.082031 2.3125 8.082031 L 8.523438 8.082031 C 8.695313 8.082031 8.835938 8.21875 8.835938 8.390625 L 8.835938 9.214844 C 8.835938 9.386719 8.695313 9.523438 8.523438 9.523438 L 7.1875 9.523438 L 12.503906 21.785156 L 15.269531 16.617188 L 11.761719 9.527344 L 10.917969 9.527344 C 10.746094 9.527344 10.605469 9.386719 10.605469 9.214844 L 10.605469 8.394531 C 10.605469 8.222656 10.746094 8.082031 10.917969 8.082031 L 15.515625 8.082031 C 15.6875 8.082031 15.824219 8.222656 15.824219 8.394531 L 15.824219 9.214844 C 15.824219 9.386719 15.6875 9.523438 15.515625 9.523438 L 14.703125 9.523438 L 16.722656 13.9375 L 19.125 9.523438 L 17.652344 9.523438 C 17.476563 9.523438 17.339844 9.386719 17.339844 9.214844 L 17.339844 8.394531 C 17.339844 8.222656 17.476563 8.082031 17.652344 8.082031 L 22.117188 8.082031 C 22.289063 8.082031 22.425781 8.222656 22.425781 8.394531 L 22.425781 9.214844 C 22.425781 9.386719 22.289063 9.523438 22.117188 9.523438 L 21.136719 9.523438 L 17.632813 15.894531 L 20.488281 21.769531 L 26 9.523438 L 24.253906 9.523438 C 24.082031 9.523438 23.941406 9.386719 23.941406 9.214844 L 23.941406 8.394531 C 23.941406 8.222656 24.082031 8.082031 24.253906 8.082031 L 29.6875 8.082031 C 29.863281 8.082031 30 8.222656 30 8.394531 Z"/></svg>`;

      // Check if api and styles exist before accessing them
      if (this.api && this.api.styles) {
        this.button.classList.add(this.api.styles.inlineToolButton);
      } else {
        console.warn('API or styles not available in CustomLink.render');
      }

      return this.button;
    } catch (error) {
      console.error('Error in CustomLink.render:', error);
      // Return a fallback button if there's an error
      const fallbackButton = document.createElement('button');
      fallbackButton.type = 'button';
      fallbackButton.textContent = 'W';
      return fallbackButton;
    }
  }

  renderActions() {
    //console.log('i am in render actions');
    this.nodes.wrapper = this.make('div', this.CSS.wrapper);
    this.nodes.container = this.make('div', this.CSS.container);
    this.nodes.inputHolder = this.makeInputHolder();
    this.nodes.filterHolder = this.makeFilterHolder();
    this.nodes.ul = this.makeDropdown();

    this.nodes.container.appendChild(this.nodes.inputHolder);
    this.nodes.container.appendChild(this.nodes.filterHolder);
    this.nodes.container.appendChild(this.nodes.ul);
    this.nodes.wrapper.appendChild(this.nodes.container);
    return this.nodes.wrapper;
  }

  surround(range) {
    console.log('🔥 CustomLink surround() called - W button clicked!');
    console.log('🔥 Range received:', range);
    
    if (!range) {
      console.warn('Range is undefined in CustomLink.surround');
      return;
    }
    this.range = range;
    this.toggleActions();
  }

  toggleActions() {
    console.log('🔥 toggleActions() called, inputOpened:', this.inputOpened);
    if (!this.inputOpened) {
        console.log('🔥 Opening WikiLink popup...');
        this.openActions(true);
    } else {
        console.log('🔥 Closing WikiLink popup...');
        this.closeActions(false);
    }
  }

  openActions(needFocus=false) {
    this.nodes.wrapper.classList.remove(this.CSS.wrapper);
    this.nodes.wrapper.classList.add(this.CSS.wrapperShowed);
    
    // Check if we're editing an existing link and show its name
    this.checkAndShowExistingLink();
    
    if (needFocus) {
      this.nodes.input.focus();
    }
    this.inputOpened = true;
  }

  closeActions() {
    this.nodes.wrapper.classList.remove(this.CSS.wrapperShowed);
    this.nodes.wrapper.classList.add(this.CSS.wrapper);
    this.nodes.input.value = '';
    // Hide the selected display when closing
    if (this.nodes.selectedDisplay) {
      this.nodes.selectedDisplay.style.display = 'none';
    }
    this.inputOpened = false;
  }

  // Method to show selected item name in the popup
  showSelectedItem(name, type = 'wiki') {
    if (this.nodes.selectedDisplay) {
      const icon = type === 'form' ? '📝' : '📄';
      this.nodes.selectedDisplay.innerHTML = `
        <strong>${icon} Selected:</strong><br/>
        <span style="color: #007bff; font-weight: 500;">${name}</span>
      `;
      this.nodes.selectedDisplay.style.display = 'block';
    }
  }

  // Check if we're editing an existing link and show its readable name
  checkAndShowExistingLink() {
    try {
      console.log('=== CHECKING FOR EXISTING LINK ===');
      
      // Find if the current selection contains a link
      const existingLink = this.api.selection.findParentTag(this.tag, this.class);
      console.log('findParentTag result:', existingLink);
      console.log('this.tag:', this.tag);
      console.log('this.class:', this.class);
      
      // Also try alternative methods to find the link
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        const container = range.commonAncestorContainer;
        const parentElement = container.nodeType === Node.TEXT_NODE ? container.parentElement : container;
        const linkElement = parentElement.closest('a');
        console.log('Alternative link detection:', linkElement);
        
        if (linkElement && linkElement.href) {
          console.log('Found existing link via alternative method:', linkElement.href);
          
          // Look up the readable name for this link
          const readableName = this.findReadableNameFromHref(linkElement.href);
          console.log('Readable name found:', readableName);
          
          if (readableName) {
            const linkType = this.getLinkType(linkElement.href);
            this.showSelectedItem(readableName, linkType);
            console.log('Showing existing link name:', readableName);
            return;
          }
        }
      }
      
      if (existingLink && existingLink.href) {
        console.log('Found existing link via API:', existingLink.href);
        
        // Look up the readable name for this link
        const readableName = this.findReadableNameFromHref(existingLink.href);
        if (readableName) {
          const linkType = this.getLinkType(existingLink.href);
          this.showSelectedItem(readableName, linkType);
          console.log('Showing existing link name:', readableName);
        }
      } else {
        console.log('No existing link found');
      }
    } catch (error) {
      console.error('Error checking existing link:', error);
    }
  }

  // Find the readable name from a link href
  findReadableNameFromHref(href) {
    try {
      console.log('=== FINDING READABLE NAME ===');
      console.log('href:', href);
      console.log('Available wikiPages:', this.config.wikiPages ? this.config.wikiPages.length : 'none');
      console.log('Available forms:', this.config.forms ? this.config.forms.length : 'none');
      
      // Extract ID from different types of links
      let targetId = null;
      
      // Handle wiki links: /app/wikiview/ID
      if (href.includes('/app/wikiview/')) {
        targetId = href.split('/app/wikiview/')[1];
        console.log('Extracted wiki ID:', targetId);
        
        if (targetId && this.config.wikiPages) {
          console.log('Searching through wiki pages for ID:', targetId);
          this.config.wikiPages.forEach((page, index) => {
            console.log(`Wiki page ${index}:`, {guid: page.guid, WikiPageID: page.WikiPageID, Name: page.Name});
          });
          
          const wikiPage = this.config.wikiPages.find(page => page.guid === targetId || page.WikiPageID === targetId);
          console.log('Found wiki page:', wikiPage);
          
          if (wikiPage) {
            const name = wikiPage.Name || wikiPage.name || wikiPage.title;
            console.log('Returning wiki name:', name);
            return name;
          }
        }
      }
      
      // Handle form template links: {{patient_link_for_form_ID}}
      if (href.includes('{{patient_link_for_form_') && href.includes('}}')) {
        const match = href.match(/\{\{patient_link_for_form_(.+?)\}\}/);
        if (match) {
          targetId = match[1];
          console.log('Extracted form ID:', targetId);

          if (targetId && this.config.forms) {
            console.log('Searching through forms for ID:', targetId);
            this.config.forms.forEach((form, index) => {
              console.log(`Form ${index}:`, {FormIDForWeb: form.FormIDForWeb, Name: form.Name});
            });

            const form = this.config.forms.find(f => f.FormIDForWeb === targetId);
            console.log('Found form:', form);

            if (form) {
              const name = form.Name || form.name || form.title;
              console.log('Returning form name:', name);
              return name;
            }
          }
        }
      }

      // Handle packet template links: {{patient_link_for_packet_ID}}
      // Sibling of the form block above. Packets live in a separate list passed via config.packets.
      if (href.includes('{{patient_link_for_packet_') && href.includes('}}')) {
        const match = href.match(/\{\{patient_link_for_packet_(.+?)\}\}/);
        if (match) {
          targetId = match[1];
          console.log('Extracted packet ID:', targetId);

          if (targetId && this.config.packets) {
            const packet = this.config.packets.find(p => p.PacketID === targetId);
            console.log('Found packet:', packet);
            if (packet) {
              const name = packet.Name || packet.name || packet.title;
              console.log('Returning packet name:', name);
              return name;
            }
          }
        }
      }

      console.log('No readable name found for href:', href);
      return null;
    } catch (error) {
      console.error('Error finding readable name from href:', error);
      return null;
    }
  }

  // Determine link type from href
  getLinkType(href) {
    if (href.includes('/app/wikiview/')) {
      return 'wiki';
    } else if (href.includes('{{patient_link_for_form_')) {
      return 'form';
    } else if (href.includes('{{patient_link_for_packet_')) {
      return 'packet';
    }
    return 'wiki'; // default
  }

    // Enhance all existing links in the editor
  _enhanceExistingLinks() {
    try {
      console.log('=== ENHANCING EXISTING LINKS ===');
      
      // Find all existing links in the editor
      const editorElement = document.querySelector('.codex-editor__redactor');
      if (!editorElement) {
        console.log('Editor element not found');
        return;
      }
      
      const links = editorElement.querySelectorAll('a.custom-link, a[href*="/app/wikiview/"], a[href*="{{patient_link_for_form_"], a[href*="{{patient_link_for_packet_"]');
      console.log('Found existing links:', links.length);
      
      links.forEach((link, index) => {
        console.log(`Processing link ${index}:`, {
          href: link.href,
          textContent: link.textContent,
          className: link.className,
          hasDataRealHref: !!link.getAttribute('data-real-href')
        });
        
        // Skip if already processed
        if (link.getAttribute('data-real-href')) {
          console.log(`Link ${index} already processed, skipping`);
          return;
        }
        
        const rawHref = link.getAttribute('href');
        const readableName = this.findReadableNameFromHref(rawHref);
        console.log(`Readable name lookup result for ${rawHref}:`, readableName);

        if (readableName) {
          console.log(`Found readable name for link ${index}:`, readableName);

           // Store the raw attribute value (not link.href which browser-resolves into a full URL with encoding)
           const realHref = rawHref;
           console.log(`Setting data-real-href to:`, realHref);
           console.log(`Setting href to:`, readableName);
           
           link.setAttribute('data-real-href', realHref);
           link.setAttribute('href', readableName);
           link.setAttribute('data-link-name', readableName);
           link.setAttribute('data-link-type', this.getLinkType(realHref));
           link.setAttribute('title', `Link to: ${readableName}`);
           
           // Verify the change
           console.log(`After update - href is now:`, link.href);
           console.log(`After update - data-real-href is:`, link.getAttribute('data-real-href'));
           
           // Add click handler to navigate to real URL
           link.addEventListener('click', this._handleLinkClick.bind(this));
        } else {
          console.log(`No readable name found for link ${index} with href:`, link.href);
        }
      });
      
      // Set up a global mutation observer to catch new links
      this._setupLinkObserver();
      
    } catch (error) {
      console.error('Error enhancing existing links:', error);
    }
  }

     // Set up mutation observer to catch dynamically added links
  _setupLinkObserver() {
    if (this._linkObserver) return; // Already set up
    
    const editorElement = document.querySelector('.codex-editor__redactor');
    if (!editorElement) return;
    
    this._linkObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const links = node.querySelectorAll ? node.querySelectorAll('a.custom-link, a[href*="/app/wikiview/"], a[href*="{{patient_link_for_form_"], a[href*="{{patient_link_for_packet_"]') : [];
            links.forEach(link => {
              // Skip if already processed
              if (link.getAttribute('data-real-href')) return;

              const rawHref = link.getAttribute('href');
              const readableName = this.findReadableNameFromHref(rawHref);
              if (readableName) {
                const realHref = rawHref;
                link.setAttribute('data-real-href', realHref);
                link.setAttribute('href', readableName);
                link.setAttribute('data-link-name', readableName);
                link.setAttribute('title', `Link to: ${readableName}`);
                link.addEventListener('click', this._handleLinkClick.bind(this));
              }
            });
          }
        });
      });
    });
    
    this._linkObserver.observe(editorElement, {
      childList: true,
      subtree: true
    });
  }

  // Handle link clicks to navigate to the real URL
  _handleLinkClick(event) {
    event.preventDefault();
    
    const link = event.currentTarget;
    const realHref = link.getAttribute('data-real-href');
    
    if (realHref) {
      console.log('Navigating to real URL:', realHref);
      
      // Handle different types of links
      if (realHref.includes('/app/wikiview/')) {
        // Navigate to wiki page
        window.location.href = realHref;
      } else if (realHref.includes('{{patient_link_for_form_')) {
        // Form template — only works when sent via SMS/email; no in-browser navigation.
        console.log('Form template link clicked:', realHref);
      } else if (realHref.includes('{{patient_link_for_packet_')) {
        // Packet template — same behavior as form template.
        console.log('Packet template link clicked:', realHref);
      } else {
        // Fallback to regular navigation
        window.location.href = realHref;
      }
    }
  }

  wrap(range, id='', shortUrl='', displayName='') {
    console.log(`CustomLink.wrap called with id: ${id}, shortUrl: ${shortUrl}, displayName: ${displayName}`);
    if (!range) {
      console.warn('Range is undefined in CustomLink.wrap');
      this.closeActions();
      this.api.inlineToolbar.close();
      return;
    }
    try {
      // If the range is inside an existing link, unwrap it first so the old <a> element
      // (with its stale data-real-href) doesn't remain in the DOM alongside the new link.
      // Use multiple strategies because commonAncestorContainer may be the <p> if the
      // selection extends even slightly beyond the link boundary.
      const ancestor = range.commonAncestorContainer;
      let parentLink = ancestor.nodeType === Node.ELEMENT_NODE
        ? ancestor.closest('a')
        : ancestor.parentElement?.closest('a');
      if (!parentLink) {
        // Try startContainer — if user selected left-to-right, start is inside the link
        const startEl = range.startContainer.nodeType === Node.ELEMENT_NODE
          ? range.startContainer
          : range.startContainer.parentElement;
        parentLink = startEl?.closest('a') || null;
      }
      if (!parentLink) {
        // Try endContainer — if user selected right-to-left, end is inside the link
        const endEl = range.endContainer.nodeType === Node.ELEMENT_NODE
          ? range.endContainer
          : range.endContainer.parentElement;
        parentLink = endEl?.closest('a') || null;
      }
      if (!parentLink) {
        // Last resort: use EditorJS API to find parent tag
        try {
          parentLink = this.api.selection.findParentTag(this.tag, this.class);
        } catch(e) { /* ignore */ }
      }
      if (parentLink) {
        const fragment = document.createDocumentFragment();
        while (parentLink.firstChild) {
          fragment.appendChild(parentLink.firstChild);
        }
        parentLink.replaceWith(fragment);
      }

      const selectedText = range.extractContents();
      console.log('Selected text for linking:', selectedText.textContent);
      
      const link = document.createElement(this.tag);
      
      // Determine if this is a form or packet template link
      const isFormTemplate = shortUrl.includes('{{patient_link_for_form_');
      const isPacketTemplate = shortUrl.includes('{{patient_link_for_packet_');
      const isPatientTemplate = isFormTemplate || isPacketTemplate;

      if (isPatientTemplate) {
        // Form/packet template links: Store template in href but make non-navigable
        link.setAttribute('href', shortUrl);
        link.classList.add(this.class, isPacketTemplate ? 'packet-template-link' : 'form-template-link');

        // Prevent default click behavior for form/packet templates
        link.addEventListener('click', (event) => {
          event.preventDefault();
          const label = isPacketTemplate ? 'form packet' : 'form';
          alert(`This ${label} link will work when sent to patients via email or SMS, but cannot be opened directly in the browser.`);
          return false;
        });

        // Visual styling to indicate it's not clickable
        link.style.cssText = `
          color: #6c757d !important;
          text-decoration: underline dotted !important;
          cursor: help !important;
        `;
      } else {
        // Wiki links: Normal navigable links
        const href = shortUrl !== '' ? shortUrl : `/app/wikiview/${id}`;
        link.setAttribute('href', href);
        link.classList.add(this.class);
      }

      // Always use the original selected text as the link text
      link.appendChild(selectedText);

      // Store additional attributes
      if (displayName && displayName.trim() !== '') {
        let titlePrefix;
        if (isPacketTemplate) titlePrefix = `Form Packet Template: ${displayName} (works in patient emails/SMS)`;
        else if (isFormTemplate) titlePrefix = `Form Template: ${displayName} (works in patient emails/SMS)`;
        else titlePrefix = `Link to: ${displayName}`;
        link.setAttribute('title', titlePrefix);
        link.setAttribute('data-link-name', displayName);
        link.setAttribute('data-link-type', isPacketTemplate ? 'packet' : (isFormTemplate ? 'form' : 'wiki'));
      }
      
      console.log('Created link element:', {
        href: link.getAttribute('href'),
        class: link.className,
        text: link.textContent,
        title: link.getAttribute('title'),
        linkTarget: displayName,
        outerHTML: link.outerHTML
      });
      
      if (this.range) {
        this.range.insertNode(link);
      } else {
        console.warn('this.range is undefined in CustomLink.wrap');
        range.insertNode(link);
      }
      
      this.closeActions();
      this.api.inlineToolbar.close();
      link.focus();
      
      console.log('WikiLink successfully created and inserted into DOM');
      console.log('Link outerHTML after insertion:', link.outerHTML);
      
      // Verify link is actually in the DOM
      setTimeout(() => {
        const editorElement = document.querySelector('.codex-editor__redactor');
        if (editorElement) {
          const foundLink = editorElement.querySelector(`a[href="${link.getAttribute('href')}"]`);
          console.log('Link verification in DOM:', foundLink ? 'FOUND' : 'NOT FOUND');
          if (foundLink) {
            console.log('Verified link HTML:', foundLink.outerHTML);
          }
        }
      }, 100);
    } catch (error) {
      console.error('Error in CustomLink.wrap:', error);
      this.closeActions();
      this.api.inlineToolbar.close();
    }
  }

  unwrap(range) {
    const link = this.api.selection.findParentTag(this.tag, this.class);
    const text = range.extractContents();
    link.remove();
    range.insertNode(text);
  }

  checkState(selection) {
    /*
    const link = this.api.selection.findParentTag(this.tag);
    this.state = !!link;
    */

    // Check if selection is valid before proceeding
    if (!selection || !selection.anchorNode) {
      this.state = false;
      return;
    }

    const link = selection.anchorNode;
    if(!link) {
      this.state = false;
      return;
    }

    const anchorElement = link instanceof Element ? link : link.parentElement;
    if (!anchorElement) {
      this.state = false;
      return;
    }

    this.state = !!anchorElement.closest('a');
  }

  makeInputHolder() {
    try {
      const inputHolder = this.make('div', this.CSS.inputHolder);

      // Create input element with error handling
      try {
        this.nodes.input = this.make('input', [this.CSS.input, this.CSS.inputEl], {
          contentEditable: true,
          id: 'search-input'
        });
      } catch (error) {
        console.error('Error creating input element:', error);
        // Create a fallback input element
        this.nodes.input = document.createElement('input');
        this.nodes.input.id = 'search-input';
      }

      let _this = this;

      // Ensure config properties exist before using them
      const wikiPages = Array.isArray(this.config.wikiPages) ? this.config.wikiPages : [];
      const forms = Array.isArray(this.config.forms) ? this.config.forms : [];

      // Sort alphabetically by Name (ascending)
      let allListMembers = [...wikiPages, ...forms].sort((a, b) =>
        (a.Name || '').toLowerCase().localeCompare((b.Name || '').toLowerCase())
      );

      // Add event listener with error handling
      try {
        this.nodes.input.addEventListener('input', (event) => {
          try {
            if (event && event.target && typeof event.target.value !== 'undefined') {
              _this.filterList(event.target.value, allListMembers);
            } else {
              console.warn('Invalid event or target in input event listener');
            }
          } catch (error) {
            console.error('Error in input event handler:', error);
          }
        });
      } catch (error) {
        console.error('Error adding event listener to input:', error);
      }

      // Set placeholder text
      if (wikiPages.length > 0) {
        this.nodes.input.placeholder = 'Search by typing a name here...';
      } else {
        this.nodes.input.placeholder = 'No results found!';
      }

      // Create a display area to show selected item name
      this.nodes.selectedDisplay = document.createElement('div');
      this.nodes.selectedDisplay.style.cssText = `
        padding: 8px 12px;
        margin-top: 8px;
        background: #f8f9fa;
        border: 1px solid #e9ecef;
        border-radius: 6px;
        font-size: 13px;
        color: #495057;
        display: none;
        word-wrap: break-word;
      `;

      // Append input and display to holder
      try {
        inputHolder.appendChild(this.nodes.input);
        inputHolder.appendChild(this.nodes.selectedDisplay);
      } catch (error) {
        console.error('Error appending elements to holder:', error);
      }

      return inputHolder;
    } catch (error) {
      console.error('Error in makeInputHolder:', error);
      // Return a fallback input holder
      const fallbackHolder = document.createElement('div');
      return fallbackHolder;
    }
  }

  makeFilterHolder() {
    const filterHolder = this.make('div', this.CSS.filterHolder);
    let _this = this;

    this.nodes.wikisSpan = this.make('span', ['ml-2', 'filtertext'], {
    })

    this.nodes.a1 = this.make('a', null,
      {
        href: '#',
        innerText: 'Show Wikis Only',
      }
    );

    this.nodes.a1.addEventListener('click', (event) => {
      this.showOnly = 'WIKIS';
      //console.dir(event);
      //console.log('clicked wikis');
      let searchInput = document.getElementById('search-input');
      //console.log(`search input value: ${searchInput.value}`);
      _this.filterList(searchInput.value, this.config.wikiPages);
    });

    this.nodes.a2 = this.make('a', null,
      {
        href: '#',
        innerText: 'Show Forms Only'
      }
    );

    this.nodes.a2.addEventListener('click', (event) => {
      this.showOnly = 'FORMS';
      //console.dir(event);
      //console.log('clicked forms');
      let searchInput = document.getElementById('search-input');
      //console.log(`search input value: ${searchInput.value}`);
      _this.filterList(searchInput.value, this.config.forms);
    });

    this.nodes.wikisSpan.appendChild(this.nodes.a1);

    this.nodes.formsSpan = this.make('span', ['ml-5', 'filtertext'], {
    });

    this.nodes.formsSpan.appendChild(this.nodes.a2);

    if(this.config.forms.length > 0) {
      filterHolder.appendChild(this.nodes.wikisSpan);
      filterHolder.appendChild(this.nodes.formsSpan);
    }

    return filterHolder;
  }

  // https://medium.com/javascript-in-plain-english/simple-suggest-as-you-type-es6-3b6c0fb6489a
  filterList(key, members) {

    let listEl = document.getElementById('MemberList');
    listEl.innerHTML = '';  // <-- Clear the field to avoid repeated entries.

    if(key === '') {
      this.makeList(listEl);
    } else {

      let _this = this;

      for (let i = 0; i < members.length; i++) {
          if ((members[i].Name.toLowerCase()).indexOf(key.toLowerCase()) > -1) {
              let item = document.createElement("li");
              item.classList.add(this.CSS.li);

              // Determine type: packet (has _isPacket flag), form (has FormIDForWeb), or wiki
              const isPacket = !!members[i]._isPacket;
              const isForm = !isPacket && members[i].FormIDForWeb !== undefined;
              let itemId;
              let itemType;
              if (isPacket) {
                itemId = members[i].PacketID;
                itemType = 'packet';
              } else if (isForm) {
                itemId = members[i].FormIDForWeb;
                itemType = 'form';
              } else {
                itemId = members[i].WikiPageID;
                itemType = 'wiki';
              }

              item.setAttribute("id", itemId);
              item.setAttribute("data-type", itemType);

              // If ShortUrl exists, also set it as a separate attribute
              if(members[i].ShortUrl) {
                item.setAttribute("shortUrl", members[i].ShortUrl);
              }

              // Render PACKET badge for packet entries so search results match the default list view.
              const safeName = String(members[i].Name || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
              item.innerHTML = isPacket
                ? `<span class="packet-badge">PACKET</span> ${safeName}`
                : safeName;

              // Click handler — walk up to <li> in case user clicks the badge span.
              item.addEventListener('click', function(e) {
                let liEl = e.target && e.target.nodeName === 'LI' ? e.target : (e.target && e.target.closest ? e.target.closest('li') : null);
                if (!liEl) return;
                if (!_this.range) {
                  console.warn('Range is undefined in listItemOnClickEvent');
                  _this.closeActions();
                  _this.api.inlineToolbar.close();
                  return;
                }

                const clickedType = liEl.getAttribute('data-type');
                // Display name excludes the PACKET badge prefix.
                const displayName = (liEl.textContent || liEl.innerText || '').replace(/^\s*PACKET\s+/, '').trim();
                const clickedId = liEl.getAttribute('id');

                _this.showSelectedItem(displayName, clickedType);

                setTimeout(() => {
                  if (clickedType === 'form') {
                    const formUrl = `{{patient_link_for_form_${clickedId}}}`;
                    _this.wrap(_this.range, clickedId, formUrl, displayName);
                  } else if (clickedType === 'packet') {
                    const packetUrl = `{{patient_link_for_packet_${clickedId}}}`;
                    _this.wrap(_this.range, clickedId, packetUrl, displayName);
                  } else {
                    // Wiki link
                    const shortUrlAttr = liEl.getAttribute('shortUrl');
                    if (shortUrlAttr) {
                      _this.wrap(_this.range, clickedId, shortUrlAttr, displayName);
                    } else {
                      _this.wrap(_this.range, clickedId, '', displayName);
                    }
                  }
                }, 1000);
              }, false);

              if (listEl.childNodes.length < 5) {
                listEl.appendChild(item);
              }
          }
          if (key.length < 1) {
              listEl.innerHTML = '';
              //presetMembers.innerHTML = userList(members.slice(0, 3));
              this.makeList(listEl);
          }
      }
    }
  };

  makeDropdown() {
    const ul = this.make('ul', this.CSS.ul);
    ul.setAttribute("id", "MemberList");
    this.makeList(ul);
    return ul;
  }

  makeList(ul) {
    console.log('=== makeList Debug ===');
    console.log('this.config:', this.config);
    console.log('this.showOnly:', this.showOnly);
    console.log('wikiPages available:', this.config.wikiPages.length);
    console.log('forms available:', this.config.forms.length);

    // Sort wiki pages and forms alphabetically by Name (ascending)
    const sortedWikiPages = [...this.config.wikiPages].sort((a, b) =>
      (a.Name || '').toLowerCase().localeCompare((b.Name || '').toLowerCase())
    );
    const sortedForms = [...this.config.forms].sort((a, b) =>
      (a.Name || '').toLowerCase().localeCompare((b.Name || '').toLowerCase())
    );

    // Get wikis
    if(this.showOnly !== 'FORMS') {
      for(let i=0; i<sortedWikiPages.length; i++) {
        //console.log(`now looking at: ${JSON.stringify(sortedWikiPages[i])}`);
        let li = this.make('li', this.CSS.li);

        // ALWAYS set the id attribute with WikiPageID - this is required for wiki links
        li.setAttribute("id", sortedWikiPages[i].WikiPageID);

        // If ShortUrl exists, also set it as a separate attribute
        if(sortedWikiPages[i].ShortUrl) {
          li.setAttribute("shortUrl", sortedWikiPages[i].ShortUrl);
        }

        li.innerHTML = sortedWikiPages[i].Name;
        let _this = this;
        li.addEventListener("click",function(e) {
          if(e.target && e.target.nodeName == "LI") {
            if (!_this.range) {
              console.warn('Range is undefined in li click event handler');
              _this.closeActions();
              _this.api.inlineToolbar.close();
              return;
            }
            
            // Get the display name from the clicked item
            const displayName = e.target.textContent || e.target.innerText || '';
            
            // Show selected item in popup
            _this.showSelectedItem(displayName, 'wiki');
            
            // Auto-confirm after showing selection
            setTimeout(() => {
              if(e.target.shortUrl)
                _this.wrap(_this.range, e.target.id, e.target.attributes['shortUrl'].nodeValue, displayName);
              else
                _this.wrap(_this.range, e.target.id, '', displayName);
            }, 1000);
          }
        });
        ul.appendChild(li);
      }
    }

    if(this.showOnly !== 'WIKIS') {
      // Get forms AND packets. Packets are flagged via `_isPacket: true` by the caller
      // (WikiCreate.vue / WikiEdit.vue merge forms + packets before passing to config).
      for(let i=0; i<sortedForms.length; i++) {
        let li = this.make('li', this.CSS.li);

        const isPacket = !!sortedForms[i]._isPacket;
        const id = isPacket ? sortedForms[i].PacketID : sortedForms[i].FormIDForWeb;
        li.setAttribute("id", id);
        if (isPacket) li.setAttribute("data-is-packet", "true");

        // Render a PACKET badge before the name so packets stand out in the picker.
        const safeName = String(sortedForms[i].Name || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        li.innerHTML = isPacket
          ? `<span class="packet-badge">PACKET</span> ${safeName}`
          : safeName;

        let _this = this;

        li.addEventListener("click",function(e) {
          // The click target may be the badge span — walk up to the <li>.
          let liEl = e.target && e.target.nodeName === 'LI' ? e.target : (e.target && e.target.closest ? e.target.closest('li') : null);
          if (!liEl) return;
          if (!_this.range) {
            console.warn('Range is undefined in li click event handler for forms/packets');
            _this.closeActions();
            _this.api.inlineToolbar.close();
            return;
          }

          const clickedIsPacket = liEl.getAttribute('data-is-packet') === 'true';
          // Display name should be the name only, without the PACKET badge prefix.
          const displayName = (liEl.textContent || liEl.innerText || '').replace(/^\s*PACKET\s+/, '').trim();

          _this.showSelectedItem(displayName, clickedIsPacket ? 'packet' : 'form');

          setTimeout(() => {
            const idVal = liEl.getAttribute('id');
            const u = clickedIsPacket
              ? `{{patient_link_for_packet_${idVal}}}`
              : `{{patient_link_for_form_${idVal}}}`;
            _this.wrap(_this.range, idVal, u, displayName);
          }, 1000);
        });
        ul.appendChild(li);
      }
    }
  }

  /**
   * Helper method for elements creation
   * @param tagName
   * @param classNames
   * @param attributes
   * @return {HTMLElement}
  */
  make(tagName, classNames = null, attributes = {}) {
      let el = document.createElement(tagName);

      if (Array.isArray(classNames)) {
          el.classList.add(...classNames);
      } else if (classNames) {
          el.classList.add(classNames);
      }

      for (let attrName in attributes) {
          el[attrName] = attributes[attrName];
      }

      return el;
  }
}